<template>
  <section class="home-wrap-content-sec select" :class="isHomeTitle ? 'is-home-list' : ''">
    <div class="line"></div>
    <div class="title">为何选择我们</div>
    <div class="home-wrap-content-sec-select">
      <div class="home-wrap-content-sec-select-item">
        <img src="../../components/home/assets/icon-transparent-procedure.svg" alt="">
        <p>过程更透明</p>
        <div class="home-wrap-content-sec-select-item-text">圣诉平台为您提供完整详细的策略方案、时间图和关系图，以及分阶段案件进展报告。让法律服务每一步都清晰可见。</div>
      </div>
      <div class="home-wrap-content-sec-select-item">
        <img src="../../components/home/assets/icon-reasonable-price.svg" alt="">
        <p>收费更合理</p>
        <div class="home-wrap-content-sec-select-item-text">根据服务类型，拆分成明确的服务环节和步骤，只提供您所需的、所想的。让法律服务也实现“真材实料”“一分钱一分货”。</div>
      </div>
      <div class="home-wrap-content-sec-select-item">
        <img src="../../components/home/assets/icon-predictable-result.svg" alt="">
        <p>结果可预期</p>
        <div class="home-wrap-content-sec-select-item-text">通过法律大数据和人工智能技术，全面综合5988万案件的经验和242万条法规材料，帮您找到最合理合适的解决方案。</div>
      </div>
    </div>
    <div class="home-wrap-content-sec-select">
      <div class="home-wrap-content-sec-select-width">
        <img src="../../components/home/assets/pic-professional-team.png" alt="">
        <div class="home-wrap-content-sec-select-width-item-txt">
          <p>放心、可靠和专业的服务团队</p>
          <div class="home-wrap-content-sec-select-item-text">
            我们提供更简单、更便捷、更及时的法律服务。在全国各地，超过600名专业的律师和顾问加入了圣诉律师联盟，无论您的案件发生在哪里，我们都能根据您的具体情况，找到最适合解决您问题的律师事务所和律师团队。
          </div>
        </div>
        <div class="home-wrap-content-sec-select-width-item-compre" @click="getMeiqia">了解详情</div>
      </div>
      <div class="home-wrap-content-sec-select-width">
        <img src="../../components/home/assets/pic-efficient-tech.png" alt="">
        <div class="home-wrap-content-sec-select-width-item-txt">
          <p>先进、高效和强大的法律科技</p>
          <div class="home-wrap-content-sec-select-item-text">
            运用大数据、人工智能和云计算的技术，无论是诉讼、仲裁，也无论您是公司还是个人，圣诉律师总能提供更完善、更专业的、更高质量的法律服务，维护您的合法权益，同时取得更好的结果。
          </div>
        </div>
        <div class="home-wrap-content-sec-select-width-item-compre" @click="getMeiqia">了解详情</div>
      </div>
    </div>
  </section>
</template>

<script>
  import { clickShowMeiQia } from '@/utils/meiqia'
  export default {
    name: 'select-us',
    data () {
      return {
        isHomeTitle: false
      }
    },
    methods: {
      getMeiqia () {
        clickShowMeiQia()
      }
    },
    mounted () {
      if (this.$route.path === '/advantage') {
        this.isHomeTitle = true
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .is-home-list {
    padding-top .64rem !important
    .title  {
      margin-bottom .83rem !important
    }
  }
  .home-wrap-content-sec {
    &-select {
      width: 9.6rem
      margin 0 auto
      display flex
      justify-content space-around
      &-item {
        width: 3rem
        height: 3.2rem
        padding .19rem .2rem .32rem
        display flex
        flex-direction column
        justify-content space-around
        align-items center
        margin-bottom .56rem
        img {
          width: 1.04rem
          height: 1.04rem
        }
        p {
          font-weight: 500
          font-size: .24rem
        }
        &-text {
          font-size: .14rem;
          line-height: 2.29;
          color: #3e3a3a;
        }
      }
      &-width {
        width: 4.6rem
        height: 4.02rem;
        border: solid .01rem #d3d3d3;
        position relative
        img {
          width: 4.6rem
          height: 3.07rem
          opacity: .3
        }
        &-item-txt {
          position absolute
          top 0
          left 0
          padding .64rem .2rem .61rem .2rem
          p {
            font-weight: 500
            font-size: .24rem
            text-align center
            margin-bottom .21rem
          }
          &-text {
            font-size: .14rem;
            line-height: 2.29;
            color: #3e3a3a;
          }
        }
        &-item-compre {
          font-size: .24rem;
          text-align: center;
          line-height .9rem
          color: #ed6c00;
          cursor: pointer
        }
      }
    }
    .line {
      width: 1.32rem;
      height: .04rem;
      margin: 0 auto .32rem
      background-color: #ed6c00;
    }
    .title  {
      height: .5rem;
      font-size: .36rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #000000;
      text-align center
      margin-bottom .48rem
    }
  }
  .select {
    background #fff
    padding .48rem 0 1.16rem 0
  }
</style>



// WEBPACK FOOTER //
// src/common-components/select-us/select-us.vue